import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { AboutComponent } from './about/about.component';
import { ContactComponent } from './contact/contact.component';
import { InspectionComponent } from './inspection/inspection.component';
import { ResourcesComponent } from './resources/resources.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';

export const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'home', component: HomeComponent },
  {
    path: 'about', component: AboutComponent
  },
  { path: 'contact', component: ContactComponent },
  { path: 'inspection', component: InspectionComponent },
  { path: 'resources', component: ResourcesComponent },
  { path: 'privacy-policy', component: PrivacyPolicyComponent },

  { path: '**', redirectTo: '', pathMatch: 'full' }
];
